import React from "react";
import Header from "../../components/Header";

const PrivacyPolicy = () => {
  return (
    <>

   <Header/>
    <main>
      {/* breadcrumb start */}
      <section id="h1-breadcrumb">
        <div className=" relative pt-[150px] md:pt-[60px]">
         <h1
  data-aos="fade-up"
  className="text-3xl md:text-6xl font-black text-[#3F3D3A] leading-tight text-center"
>
  Privacy
  <span className="bg-gradient-to-r from-[#D4CB2F] via-[#E6DD57] to-[#55534F] bg-clip-text text-transparent">
    {" "}Policy
  </span>
</h1>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section className="w-full py-16 md:py-[80px]" data-aos="fade">
        <div className="theme-container mx-auto w-full text-paragraph text-[14px] md:text-base">
          <p className="mb-4 font-medium">
            "S Meera Health" refers as S Meera Health(“S Meera Health”,
            “we”, “us”, or “our”) respects the privacy of our users (“you” or
            “your”). This Privacy Policy describes how we collect, use,
            disclose, and protect your personal information when you access and
            use our website (the “Website”) and our SaaS-based healthtech
            infrastructure (the “Service”).
          </p>
          <p className="mb-2">
            <strong>1. Information We Collect</strong>
          </p>
          <p className="mb-4">
            We collect several types of information from and about you when you
            use the Website and Service:
          </p>
          <div className="mb-4">
            <p className="mb-2">
              <strong>Personal Information:</strong> This includes information
              that can be used to identify you directly, such as your name,
              email address, phone number, and postal address. We may collect
              this information when you create an account, contact us, or use
              certain features of the Service.
            </p>
            <p className="mb-2">
              <strong>Usage Data:</strong> We collect information about your
              activity on the Website and Service, such as the pages you visit,
              the features you use, and the time you spend on the Website and
              Service.
            </p>
            <p className="mb-2">
              <strong>Device Information:</strong> We collect information about
              the device you use to access the Website and Service, such as your
              device type, operating system, browser type, IP address, and
              device identifiers.
            </p>
            <p />
          </div>
          <p className="mb-2">
            <strong>2. How We Use Your Information</strong>
          </p>
          <p className="mb-2 font-medium">We use your information to:</p>
          <div className="pl-[10px] mb-4">
            <p className="mb-2">
              - Provide and operate the Website and Service
            </p>
            <p className="mb-2">- Process your requests and transactions</p>
            <p className="mb-2">
              - Send you important information about the Website and Service,
              including updates, security alerts, and support messages
            </p>
            <p className="mb-2">
              - Communicate with you about your use of the Website and Service
            </p>
            <p className="mb-2">
              - Monitor and improve the Website and Service
            </p>
            <p className="mb-2">
              - Personalise your experience on the Website and Service
            </p>
            <p>- Comply with legal and regulatory requirements</p>
          </div>
          <p className="mb-2">
            <strong>3. Disclosure of Your Information</strong>
          </p>
          <p className="mb-2">
            We may disclose your information to third-party service providers
            who help us operate the Website and Service. These service providers
            are obligated to protect your information under the DATA PROTECTION
            ACT 2023, and are only permitted to use it for the purposes we
            instruct them.
          </p>
          <p className="mb-4">
            We may also disclose your information if we are required to do so by
            law or in the good faith belief that such disclosure is necessary
            to: Comply with a legal process & Protect the rights or safety of
            you, S Meera Health, or others
          </p>
          <p className="mb-2">
            <strong>4. Data Retention</strong>
          </p>
          <p className="mb-4">
            We will retain your information for as long as your account is
            active or as needed to provide you with the Website and Service. We
            may also retain your information for legal, regulatory, and audit
            purposes.
          </p>
          <p className="mb-2">
            <strong>5. Your Choices</strong>
          </p>
          <p className="mb-2 font-medium">
            You have certain choices regarding your information:
          </p>
          <div className="pl-[10px] mb-4">
            <p className="mb-2">
              - You can access and update your personal information through your
              account settings.
            </p>
            <p>
              - You can unsubscribe from our marketing communications by
              following the unsubscribe instructions in those communications.
            </p>
          </div>
          <p className="mb-2">
            <strong>6. Security</strong>
          </p>
          <p className="mb-4">
            We take reasonable steps to protect your information from
            unauthorized access, disclosure, alteration, or destruction.
            However, no internet transmission or electronic storage is 100%
            secure.
          </p>
          <p className="mb-2">
            <strong>7. Children’s Privacy</strong>
          </p>
          <p className="mb-4">
            The Website and Service are not directed to children under the age
            of 18. We do not knowingly collect personal information from
            children under 18. If you are a parent or guardian and you believe
            your child has provided us with personal information, please contact
            us.
          </p>
          <p className="mb-2">
            <strong>8. International Transfers</strong>
          </p>
          <p className="mb-4">
            Your information may be transferred to and processed in countries
            other than your own. These countries may have different data
            protection laws than your own country.
          </p>
          <p className="mb-2">
            <strong>9. Changes to this Privacy Policy</strong>
          </p>
          <p className="mb-4">
            We may update this Privacy Policy from time to time. We will post
            the updated Privacy Policy on the Website. You are advised to review
            this Privacy Policy periodically for any changes.
          </p>
          <p className="mb-2">
            <strong>10. Contact Us</strong>
          </p>
          <p>
            If you have any questions about this Privacy Policy, please contact us at support@smeerahealth.com
          </p>
        </div>
      </section>
      {/* blog end  */}
    </main>
     </>
  );
};

export default PrivacyPolicy;
